<template>
	<div>
		<!-- TODO: asia tenant still using old flow and reports -->
		<asia-reports-home
			v-if="['asia_uat', 'asia'].includes($store.state.tenantId)"
		/>
		<default-reports-home v-else />
	</div>
</template>

<script>
import DefaultReportsHome from "../components/DefaultReportsHome"
import AsiaReportsHome from "../components/mockedAsia/AsiaReportsHome"
export default {
	components: {
		DefaultReportsHome,
		AsiaReportsHome
	}
}
</script>
